import { render } from "./Invitations.vue?vue&type=template&id=69777ea2"
import script from "./Invitations.vue?vue&type=script&lang=js"
export * from "./Invitations.vue?vue&type=script&lang=js"
script.render = render

export default script